import CheckoutForm from "./CheckoutForm";
import { CheckoutUIProvider } from "./CheckoutUIProvider";

const CheckoutFlowV2 = () => {
  return (
    <CheckoutUIProvider>
      <CheckoutForm />
    </CheckoutUIProvider>
  );
};

export default CheckoutFlowV2;
